import { useMemo } from 'react';

const NoContentPage = ({ route }) => {
  // Static lore messages for each route (no backend needed)
  const loreMessages = useMemo(() => ({
    whitepaper: 'Intentionally blank.',
    roadmap: 'No map. No roads. Just vibes.',
    docs: 'Documentation? We prefer mystery.',
    faq: 'Frequently Asked Questions: Why?',
    press: 'Press release: There is no press release.'
  }), []);

  const loreHeader = loreMessages[route] || 'No content found.';

  return (
    <div className="min-h-screen bg-pixel-white flex items-center justify-center p-8">
      <div className="max-w-2xl w-full text-center">
        <div className="border-2 border-charcoal p-8 bg-pixel-white shadow-pixel">
          <h1 className="text-pixel-xl text-deep-navy mb-6">
            HTTP 204
          </h1>
          <p className="text-pixel-base text-charcoal mb-8">
            No Content
          </p>
          
          {loreHeader && (
            <div className="mt-8 p-6 border-2 border-light-blue bg-pixel-white">
              <p className="text-pixel-base text-deep-navy font-mono leading-relaxed">
                X-Lore: {loreHeader}
              </p>
            </div>
          )}

          <a 
            href="/"
            className="pixel-btn pixel-btn--primary inline-block mt-8"
          >
            Back Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default NoContentPage;